<template>
  <div>
    <div class="materials">
      <p v-if="isCategoryAdvanced" class="attention mb-0">※「例文問題」にのみ適用されます。</p>
      <v-category-button v-for='material in materials'
        @click="checked(material.value)"
        :key="material.id"
        :type="material.type"
        :active="checkedList.includes(material.value[0])"
        :disabled="material.disabled"
      >
        {{material.text}}
      </v-category-button>
    </div>
  </div>
</template>

<script>
import VCategoryButton from '@/components/atoms/CategoryButton'
export default {

  components: {
    VCategoryButton
  },

  data: () => ({
    materials: [
      {id: 1, text: '英→和', type: 'eiwa', value: [1], disabled: false},
      {id: 2, text: '和→英', type: 'waei', value: [2], disabled: false},
    ]
  }),

  computed: {
    checkedList() {
      return this.$store.state.conditions.checkedArr['eiwa']
    },
    isCategoryAdvanced() {
      return this.$store.getters['conditions/isCategoryAdvanced']
    },
  },

  mounted() {
  },

  methods: {
    checked(value) {
      this.$store.commit('conditions/setCheckList', {
        listName: 'eiwa',
        value: value
      })
    },
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
.materials
  max-width 800px

.attention
  font-size 12px
</style>
